import firebase from "../firebase";
import UtilService from "@/services/UtilService";

const prepays = firebase.ref("/prepays");
const partners = firebase.ref("/partners");

class PrepayService {
    getAll(userInfo) {
        if (
            userInfo.Role === "Partner Admin" ||
            userInfo.Role === "Partner Staff"
        ) {
            return prepays.orderByChild("Partner").equalTo(userInfo['PartnerId']);
        } else {
            return prepays;
        }
    }

    getById(Id) {
        var ref = prepays.child("/" + Id);
        return ref;
    }

    create(prepay) {
        return prepays
        .orderByChild("Id")
        .equalTo(prepay["Id"] || "")
        .once("value", snapshot => {
            if (snapshot.exists()) {
                return null;
            } else {
                var newPostRef = prepays.push();
                var Id = newPostRef.key;
                const userInfo = JSON.parse(localStorage.getItem("userInfo"));
                prepay["Id"] = Id;
                prepay["CreatedDate"] = prepay[
                    "ModifiedDate"
                ] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

                return prepays.child(Id).set(prepay);
            }
        });
    }

    update(key, prepay) {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        prepay["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);
        return prepays.child(key).update(prepay);
    }

    delete(key) {
        return prepays.child(key).update({
            IsDeleted: 1
        });
    }

    deleteAll() {
        return prepays.remove();
    }

    getPartnerVal() {
        return partners;
    }
}

export default new PrepayService();
